var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"declared_oasis_explan"},[(_vm.getContentUrl)?_c('img',{staticClass:"declared_oasis_explan__inner",attrs:{"src":_vm.getContentUrl,"alt":""}}):_c('img',{staticClass:"declared_oasis_explan__inner",attrs:{"src":require("@/img/img-declared-oasis-explan.jpeg"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }